/**
 * Duodecimo view component.
 * @module components/Views/DuodecimoView
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Container as SemanticContainer } from 'semantic-ui-react';
import config from '@plone/volto/registry';
import Repasses from '../Repasses/Repasses';

/**
 * Duodecimo view component class.
 * @function Duodecimo
 * @params {object} content Content object.
 * @returns {string} Markup of the component.
 */
const DuodecimoView = (props) => {
  const { content } = props;
  const Container =
    config.getComponent({ name: 'Container' }).component || SemanticContainer;
  const { title, description, tabela_repasses } = content;

  return (
    <Container id="page-document" className="view-wrapper duodecimo-view">
      <h1 className="documentFirstHeading">{title}</h1>
      {description && <p className="documentDescription">{description}</p>}
      <Repasses repasses={tabela_repasses} />
    </Container>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
DuodecimoView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    tabela_repasses: PropTypes.array,
  }).isRequired,
};

export default DuodecimoView;
